export default __webpack_public_path__ + "static/media/newspaper.683e4b26.svg";